import { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Input, FormField } from '../components/ui/Input';
import { useToast } from '../contexts/ToastContext';

export default function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const toast = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSending(true);
    // For now, just open a mailto. Replace with /api/contact backend endpoint when needed.
    const mailto = `mailto:hello@altcoinsmoney.com?subject=${encodeURIComponent(
      `Contact from ${name}`,
    )}&body=${encodeURIComponent(`From: ${name} <${email}>\n\n${message}`)}`;
    window.location.href = mailto;
    setTimeout(() => {
      setSending(false);
      toast.success('Opened your email client');
    }, 800);
  };

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="eyebrow mb-3">CONTACT</div>
      <h1 className="font-display text-5xl lg:text-6xl font-bold tracking-tight">
        Get in <span className="text-gradient">touch</span>
      </h1>
      <p className="mt-4 text-ink-600 max-w-xl text-lg">
        Partnerships, KYC questions, large-volume buys, technical issues. We read
        everything.
      </p>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-12">
        <Card className="lg:col-span-2">
          <form onSubmit={handleSubmit} className="space-y-5">
            <FormField label="Your name">
              <Input value={name} onChange={(e) => setName(e.target.value)} required />
            </FormField>
            <FormField label="Email">
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </FormField>
            <FormField label="Message">
              <textarea
                rows={6}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
                className="w-full px-4 py-3 rounded-2xl bg-paper-50 border border-paper-300 focus:border-violet-500 font-sans text-ink placeholder:text-ink-600/60 focus:outline-none focus:ring-2 focus:ring-violet-500/20 resize-y"
              />
            </FormField>
            <Button type="submit" isLoading={sending}>
              Send message
            </Button>
          </form>
        </Card>

        <div className="space-y-4">
          <Card>
            <div className="eyebrow mb-2">EMAIL</div>
            <a
              href="mailto:hello@altcoinsmoney.com"
              className="font-display text-lg text-ink hover:text-violet-600"
            >
              hello@altcoinsmoney.com
            </a>
          </Card>
          <Card>
            <div className="eyebrow mb-2">RESPONSE TIME</div>
            <div className="font-display text-lg">Within 24 hours</div>
            <div className="text-xs text-ink-600 mt-1">Mon–Fri, UTC</div>
          </Card>
        </div>
      </div>
    </div>
  );
}
